import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import SimpleModal from "../../components/common/SimpleModal";
import {
  setIsEditRoom,
  toggleBugModal,
  toggleRoomModal,
} from "./redux/roomSlice";
import RoomTable from "./components/RoomTable";
import RoomForm from "./components/form/RoomForm";
import AddIcon from "../../components/common/AddIcon";
import { useRoomQuery } from "../../graphql/apollo/query-hooks";
import RoomBugForm from "./components/form/RoomBugForm";

const Room = () => {
  const dispatch = useDispatch();
  const { isOpenModal, isOpenBugModal } = useSelector((state) => state.room);
  const { roomList } = useRoomQuery();

  const handleAdd = () => {
    dispatch(setIsEditRoom(false));
    dispatch(toggleRoomModal());
  };

  const handleClose = () => dispatch(toggleRoomModal());
  const handleCloseBug = () => dispatch(toggleBugModal());

  return (
    <>
      <SimpleModal
        show={isOpenModal}
        handleClose={handleClose}
        title="ຈັດການຫ້ອງເກມ"
        size="lg"
      >
        <RoomForm handleClose={handleClose} />
      </SimpleModal>
      <SimpleModal
        show={isOpenBugModal}
        handleClose={handleCloseBug}
        title="ເປີດ/ປິດບັກ"
        size="xs"
      >
        <RoomBugForm handleClose={handleCloseBug} />
      </SimpleModal>
      <Row className="lao">
        <Col lg={12}>
          <Card>
            <Card.Header>
              <Card.Title>
                <h3 className="p-1">ຈັດການຂໍ້ມູນຫ້ອງເກມ</h3>
              </Card.Title>
              <AddIcon onClick={handleAdd} />
            </Card.Header>
            <Card.Body>
              <RoomTable data={roomList} />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default Room;
